export class PreloadStatus {
  /**
   * Constructor
   *
   * @param {number} loadPercentage
   * @param {string} currentStage
   * @param {string} assetName
   */
  public constructor(
    public loadPercentage: number = null,
    public currentStage: string = null,
    public assetName: string = null,
  ) { }
}
